import styled from '@emotion/styled/macro';
import Icon from '@mdi/react';
import { BaseButton } from '../../../base/button/button';
import { Variables } from '../../../base/variables';

// Reuse table styles from claim-timeline.styles.tsx by importing them
export {
    ExpandTable,
    ExpandTD,
    ExpandTH,
    ExpandTR,
    ExpandTBody,
    ExpandTHead,
} from '../claim-timeline.styles';

export const InvoiceContainer = styled.div`
    width: 100%;
`;

export const SectionSpacer = styled.div`
    margin-top: 16px;
`;

export const ButtonSpacer = styled.div`
    margin-top: 16px;
`;

export const StyledButton = styled(BaseButton)`
    flex-grow: 1;
    margin-bottom: 8px;
    &:not(:first-of-type) {
        margin-left: 8px;
    }
`;

export const StyledLightIcon = styled(Icon)`
    fill: white;
`;

export const Subtitle = styled.div`
    font-weight: 500;
    margin-top: 10px;
`;

export const ListContainer = styled.ul`
    margin-top: 10px;
    padding-left: 20px;
`;

export const ListItem = styled.li`
    margin-top: 10px;
`;
